import {
  GET_APPLICATION_SUBSTATUS_DEF,
  GET_APPLICATION_SUBSTATUS_DEF_SUCCESS,
  API_ERROR
  
  } from "./actionTypes"
  
    
  export const getApplicationSubStatusDef = () => ({
    type: GET_APPLICATION_SUBSTATUS_DEF,
  })
  
  export const getApplicationSubStatusDefSuccess = record => ({
    type: GET_APPLICATION_SUBSTATUS_DEF_SUCCESS,
    payload: record,
  })
  
  export const applicationSubStatusDefError = error => {
    return {
      type: API_ERROR,
      payload: error,
    }
  }
  
  